import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, BookOpen, Video, Users, ShieldCheck, Gift, PlayCircle, Sparkles } from 'lucide-react';
import { ManualsVisual } from './ManualsVisual';
const valueStack = [{
  icon: BookOpen,
  label: '3 Módulos PDF'
}, {
  icon: Video,
  label: 'Clases en vivo'
}, {
  icon: PlayCircle,
  label: 'Grabadas'
}, {
  icon: Users,
  label: 'Comunidad'
}, {
  icon: ShieldCheck,
  label: 'Normativa AEA'
}, {
  icon: Gift,
  label: '+ 2 Bonus'
}];
export function Hero() {
  return <section className="relative min-h-screen pt-32 pb-16 flex items-center overflow-hidden bg-ed-black" data-id="element-214">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-215"></div>
      <div className="absolute inset-0 bg-radial-green" data-id="element-216"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-217">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-218">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-219">
            {/* Eyebrow */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 mb-7" data-id="element-220">
              <span className="relative flex h-2 w-2" data-id="element-221">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-ed-green opacity-75" data-id="element-222"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-ed-green" data-id="element-223"></span>
              </span>
              <span className="text-xs font-bold tracking-widest text-zinc-300 uppercase" data-id="element-224">
                Academia Profesional · Argentina
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black uppercase leading-[1.05] tracking-tight mb-6 text-white" data-id="element-225">
              Convertite en <br data-id="element-226" />
              <span className="text-ed-green text-glow" data-id="element-227">
                Electricista Domiciliario
              </span>{' '}
              <br data-id="element-228" />
              Profesional
            </h1>

            {/* Subheadline */}
            <p className="text-lg sm:text-xl text-zinc-400 mb-7 max-w-xl font-medium leading-relaxed" data-id="element-229">
              Aprendé instalaciones eléctricas domiciliarias desde cero con
              formación práctica, clases en vivo, normativa actualizada y
              acompañamiento profesional real.
            </p>

            {/* Value Stack Chips */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-8" data-id="element-230">
              {valueStack.map((v, i) => {
              const Icon = v.icon;
              return <motion.div key={i} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.4,
                delay: 0.3 + i * 0.07
              }} className="flex items-center gap-2 bg-ed-dark/80 border border-zinc-800 rounded-lg px-3 py-2.5 backdrop-blur-sm" data-id="element-231">
                    <div className="w-7 h-7 rounded-md bg-ed-green/10 border border-ed-green/30 flex items-center justify-center shrink-0" data-id="element-232">
                      <Icon className="w-3.5 h-3.5 text-ed-green" data-id="element-233" />
                    </div>
                    <span className="text-xs font-bold text-white uppercase tracking-wider leading-tight" data-id="element-234">
                      {v.label}
                    </span>
                  </motion.div>;
            })}
            </div>

            {/* Bullets row */}
            <div className="flex flex-wrap gap-y-2 gap-x-4 mb-8" data-id="element-235">
              {['Desde cero', 'Normativa vigente', 'Soporte profesional'].map((bullet, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-236">
                    <CheckCircle2 className="w-4 h-4 text-ed-green shrink-0" data-id="element-237" />
                    <span className="text-sm font-medium text-zinc-300" data-id="element-238">
                      {bullet}
                    </span>
                  </div>)}
            </div>

            {/* CTAs — 2 levels */}
            <div className="mb-8" data-id="element-239">
              <span className="text-xs font-black text-ed-green uppercase tracking-widest mb-3 block" data-id="element-240">
                2 niveles disponibles
              </span>
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-241">
                <a href="#planes" className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-zinc-700 text-white px-8 py-4 rounded-lg font-bold uppercase tracking-wide text-sm sm:text-base hover:border-ed-green hover:bg-ed-green/5 transition-all" data-id="element-242">
                  Acceder a Plan Profesional
                </a>
                <a href="#planes" className="inline-flex flex-col items-center justify-center gap-1.5 bg-ed-green text-ed-black px-8 py-3 rounded-lg uppercase hover:bg-ed-green-dark transition-all glow-green hover:scale-[1.02] active:scale-[0.98]" data-id="element-243">
                  <span className="inline-flex items-center gap-2 font-black tracking-wide text-sm sm:text-base" data-id="element-244">
                    Acceder a Plan Premium
                    <ArrowRight className="w-5 h-5" data-id="element-245" />
                  </span>
                  <span className="inline-flex items-center gap-1.5 bg-ed-black text-ed-green text-[11px] font-black tracking-wide normal-case px-2.5 py-1 rounded-full" data-id="element-246">
                    <Sparkles className="w-3 h-3" data-id="element-247" />
                    12 cuotas sin interés
                  </span>
                </a>
              </div>
            </div>

            {/* Trust Strip */}
            <div className="flex flex-wrap items-center gap-2 sm:gap-4 text-xs font-semibold text-zinc-500 uppercase tracking-wider" data-id="element-248">
              <span data-id="element-249">Basado en normativa AEA</span>
              <span className="hidden sm:inline w-1 h-1 rounded-full bg-zinc-700" data-id="element-250"></span>
              <span data-id="element-251">Docente profesional</span>
              <span className="hidden sm:inline w-1 h-1 rounded-full bg-zinc-700" data-id="element-252"></span>
              <span data-id="element-253">Alumnos en toda Argentina</span>
            </div>
          </motion.div>

          {/* Right Column: Visual */}
          <div className="lg:pl-10 mt-10 lg:mt-0" data-id="element-254">
            <ManualsVisual data-id="element-255" />
          </div>
        </div>
      </div>
    </section>;
}